import React, { useState } from "react";

import PageWrapper from "Components/Pages/Wrapper";
import Breadcrumb from "Components/Shared/Breadcrumb";
import { Link } from "react-router-dom";
import SelectSearch from "Components/Form/SelectSearch";
import { marSaudeIntegrationAPI } from "Requests/Order";
import { createToast } from "Utils/toastFunc";
import { Loader } from "Components/Loader";
import { Button } from "Components/Button";
import Check from "Assets/Images/check-small-purple.svg";
import Close from "Assets/Images/close.svg";
import { Header } from "../styles";
import { NavWrapper, Container } from "./styles";

const types = [
  { value: "", label: "Selecione o estado" },
  { value: "RJ", label: "RJ" },
  { value: "SP", label: "SP" },
];

export default function MarSaudeImport() {
  const [selectedSearch, setSelectedSearch] = useState({
    value: "",
    label: "Selecione o estado",
  });
  const [loading, setLoading] = useState(false);
  const [itemsImported, setItemsImported] = useState([]);

  const onSubmit = async (e) => {
    try {
      e.preventDefault();
      setLoading(true);
      setItemsImported([]);

      if (selectedSearch.value) {
        const response = await marSaudeIntegrationAPI(selectedSearch.value);

        const { message, items } = response.data;

        if (items) {
          setItemsImported(items);
        }

        if (message) createToast("success", message);

        setSelectedSearch({
          value: "",
          label: "Selecione o estado",
        });
      }
    } catch (error) {
      if (!error.response) {
        createToast(
          "info",
          "Estamos processando a planilha. Aguarde alguns minutos e confira as fichas no motion."
        );
        return;
      }

      const errMessage = error?.response?.data?.data?.error;
      if (errMessage) createToast("error", errMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageWrapper className="entry-app-content order-home-list">
      <div className="content-holder">
        <Header>
          <h1>Integração Mar Saúde</h1>
          <Breadcrumb
            list={[
              {
                path: "/pedidos/mar-saude",
                label: "pedidos",
                current: false,
              },
              {
                path: "#",
                label: "INTEGRAÇÃO MAR SAÚDE",
                current: true,
              },
            ]}
          />
        </Header>

        <NavWrapper>
          <nav className="orders-tabs">
            <Link to="/pedidos-domiciliar">EXPORTAR</Link>
            <Link to="/pedidos/importar">IMPORTAR</Link>
            <Link to="/pedido-domiciliar/motion">ENVIAR PARA O MOTION</Link>
            <Link to="#" className="current">
              Mar Saúde
            </Link>
          </nav>

          <Container>
            <p>Selecione um estado para importar a planilha padrão</p>

            <form onSubmit={onSubmit}>
              <div className="select-input">
                <SelectSearch
                  value={selectedSearch}
                  isMulti
                  isMoreSelect={false}
                  options={types}
                  valueKey="value"
                  labelKey="label"
                  placeholder="Estado"
                  onChange={(e) => setSelectedSearch(e)}
                />
              </div>

              <Button disabled={loading || !selectedSearch.value} type="submit">
                {" "}
                {loading ? <Loader size={20} color="white" /> : "Integrar"}{" "}
              </Button>
            </form>

            <div className="items-container">
              {itemsImported.length >= 1 &&
                itemsImported.map((item) => (
                  <div className="items">
                    <p>{item.paciente} </p>
                    <img src={item.enviado ? Check : Close} alt="" />
                  </div>
                ))}
            </div>
          </Container>
        </NavWrapper>
      </div>
    </PageWrapper>
  );
}
